import { ArrowRight } from "lucide-react";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import homePageAPI from "../../api/homePageApi";
import homePagePayload from "../../config.js/homePayload";


//   {
//     id: 1,
//     image: "/assets/images/frame201.jpg",
//     tags: [
//       { label: "Branding", type: "primary" },
//       { label: "Best Read", type: "secondary" },
//     ],
//     title: "Process to Start a Brand From Scratch",
//     desc: "A complete guide to building your brand from the ground up with proven strategies.",
//     author: "By Arunidhi Sharma",
//     date: "26th June 2024",
//     tall: true,
//   },
//   {
//     id: 2,
//     image: "/assets/images/frame359.jpg",
//     tags: [
//       { label: "Education", type: "education" },
//       { label: "Trending", type: "secondary" },
//     ],
//     title: "Learn How To Improve Customer Digital Experiences",
//     desc: "Simple ways to deliver exceptional digital experiences your customers will love.",
//     author: "By Jay Singh",
//     date: "27th April 2024",
//     tall: false,
//   },
//   {
//     id: 3,
//     image: "/assets/images/frame203.jpg",
//     tags: [
//       { label: "Design", type: "design" },
//       { label: "Trending", type: "secondary" },
//     ],
//     title: "Colours, Typography, Layout and Much more",
//     desc: "Design elements that create a lasting impact and build stronger brands.",
//     author: "By Rohit Gandhi",
//     date: "8th July 2024",
//     tall: false,
//   },
// ];

function ArrowIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      width="20"
      height="20"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </svg>
  );
}

function BlogCard({ blog, index }) {
  let initialAnimation = {};

  // LEFT CARD
  if (index === 0) {
    initialAnimation = { x: -60, opacity: 0 };
  }
  // RIGHT TOP CARD
  else if (index === 1) {
    initialAnimation = { x: 60, opacity: 0 };
  }
  // BOTTOM CARD
  else {
    initialAnimation = { y: 60, opacity: 0 };
  }

  return (
    <motion.div
      initial={initialAnimation}
      whileInView={{
        x: 0,
        y: 0,
        opacity: 1,
      }}
      transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1],
        delay: index * 0.15,
      }}
      viewport={{ once: false, amount: 0.1 }}
      className={`ax-insights-card${blog.tall ? " ax-insights-card-tall" : ""}`}
    >
      {/* IMAGE */}
      <Link to={`/blog/${blog?.slug}`} className="custom-blog-link-ax-b">
        <div className="ax-insights-card-img-wrap">
          <img src={blog.image} alt={blog.title} loading="lazy" />
        </div>

        {/* BODY */}

        <div className="ax-insights-card-body">
          {/* TITLE */}
          <h3 className="ax-insights-card-title">{blog.title}</h3>

          {/* DESC */}
          <p className="ax-insights-card-desc">{blog.shortDescription}</p>

          {/* FOOTER */}
          <div className="ax-insights-card-footer">
            <div className="ax-insights-author">
              <div className="ax-insights-author-name">{blog.author}</div>
              <div>
                {/* {blog.date} */}
                {new Date(blog.date).toLocaleDateString("en-GB", {
                  day: "numeric",
                  month: "short",
                  year: "numeric",
                })}
              </div>
            </div>

            <button className="ax-insights-arrow-btn" aria-label="Read more">
              <ArrowIcon />
            </button>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}

export default function InsightsSection({ blogs }) {
  // const [blogs, setBlogs] = useState([]);
  const leftCard = blogs[0];
  const rightCards = blogs.slice(1);
  return (
    <>
      {blogs && blogs.length > 0 && (
        <section className="ax-insights-sec">
          <div className="ax-insights-container">
            {/* HEADER */}
            <div className="ax-insights-header">
              <div className="ax-insights-title-line1">
                <span className="ax-insights-title-plain">Insights</span>
                <span className="ax-insights-title-bold-tag">THAT</span>
              </div>

              <div className="ax-insights-title-line2">
                <span className="ax-insights-title-cursive">Inspire</span>
                <span className="ax-insights-title-growth">Growth</span>
                <span className="ax-insights-title-dot">.</span>
              </div>

              <p className="ax-insights-subtext">
                Explore the latest trends, strategies and ideas to grow your
                business with confidence.
              </p>

              <div className="ax-insights-star-row">
                <span className="ax-insights-star">★</span>
                <div className="ax-insights-star-line" />
              </div>
            </div>

            {/* BODY */}
            <div className="ax-insights-layout">
              <div className="ax-insights-grid-wrap">
                <div className="ax-insights-grid">
                  {/* LEFT CARD COLUMN */}
                  <div style={{ gridRow: "1 / 3" }}>
                    <BlogCard blog={leftCard} index={0} />
                    <div className="ax-insights-cta-wrap d-none d-lg-block">
                      <Link to="/blog" className="ax-insights-cta-btn">
                        View All Blogs <ArrowRight />
                      </Link>
                    </div>
                  </div>

                  {/* RIGHT CARDS */}
                  {rightCards.map((blog, index) => (
                    <BlogCard key={index} blog={blog} index={index + 1} />
                  ))}
                </div>
              </div>
            </div>

            {/* MOBILE BUTTON */}
            {/* <div className="ax-insights-cta-wrap d-lg-none d-block">
              <Link to="/blog" className="ax-insights-cta-btn">
                View All Blogs <ArrowRight />
              </Link>
            </div> */}
          </div>
        </section>
      )}
    </>
  );
}
